
/**
 * Simple utilities for network error detection and retry with exponential backoff.
 */
export function isNetworkError(e: any) {
  // Chrome & most browsers
  return (
    e?.name === "TypeError" && (e?.message?.includes("Failed to fetch") || e?.message?.includes("NetworkError")) ||
    e?.message?.includes("Network request failed") ||
    !!navigator && !navigator.onLine
  );
}

export async function retry<T>(
  fn: () => Promise<T>,
  maxRetries = 2,
  initialDelay = 350
): Promise<T> {
  let attempt = 0;
  let delay = initialDelay;

  while (attempt <= maxRetries) {
    try {
      return await fn();
    } catch (err) {
      if (attempt === maxRetries || !isNetworkError(err)) {
        throw err;
      }
      // Wait before retry - exponential backoff
      await new Promise((resolve) => setTimeout(resolve, delay));
      delay *= 2;
      attempt += 1;
    }
  }
  throw new Error("Unreachable"); // Should not happen
}
